module.exports = __webpack_public_path__ + "static/media/oct_logo.1d61053c.png";